import get from 'lodash.get';
import { CheckoutTrackingStepOptionTypes } from '~app/modules/checkout/models';
import { GaTrackingHelpersService } from '~shared/modules/ga-tracking/utils/ga-tracking-helpers.service';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';
import { GaTrackingEventName, GATrackingEventType, GaTrackingStringConstantEnum } from '../../constants';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEvent } from '../ga-tracking-event.model';
import { getCategoryNameHelper } from '~app/modules/generic/helpers/get-category-name.helper';

export class GATrackingCheckoutEvent implements GATrackingEvent {

  constructor(
    private validOffers: CartOfferLine[],
    private actionField: { step: string, option?: CheckoutTrackingStepOptionTypes },
  ) {
  }

  public updateValidOffers(offers: CartOfferLine[]): void {
    this.validOffers = offers;
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.Checkout;
  }

  getPayload(): GATrackingEventPayload {
    const products = this.validOffers.map((offer: CartOfferLine) => {
      const categoryTree = offer.trackingData?.categoryTree?.map(getCategoryNameHelper) ?? [];
      const dimension29 = GaTrackingHelpersService.getReferencePriceTypeFromOffer(offer);
      const dimension31 = get(offer, 'trackingData.dimension31', 0);
      const recommendation = get(offer, 'trackingData.recommendation') ?
        GaTrackingStringConstantEnum.Yes : GaTrackingStringConstantEnum.No;
      const vasData = GaTrackingHelpersService.getVasRelatedDataFromOffer(offer);

      return {
        name: get(offer, 'item.name', ''),
        id: get(offer, 'item.id', ''),
        price: get(offer, 'price.total', ''),
        quantity: get(offer, 'quantity', ''),
        category: categoryTree.length > 0 ? categoryTree.join('/') : '',
        category_id: get(offer, 'trackingData.leafCategoryId', ''),
        dimension42: get(offer, 'trackingData.dimension42', 0),
        dimension27: get(offer, 'trackingData.offerType', 'other'),
        dimension14: get(offer, 'trackingData.volumePricingShown', 'No'),
        dimension22: get(offer, 'trackingData.otherOffersShown', 'No'),
        dimension12: get(offer, 'trackingData.onSale', false),
        dimension15: get(offer, 'trackingData.sellerName', ''),
        dimension32: get(offer, 'trackingData.EECLabel', GaTrackingStringConstantEnum.NoEECLabel),
        dimension33: recommendation,
        dimension43: get(offer, 'trackingData.dimension43', '0'),
        ...(!!dimension29 ? { dimension29 } : {}),
        ...(!!dimension31 ? { dimension31 } : {}),
        dimension51: get(offer, 'trackingData.dimension51', GaTrackingStringConstantEnum.No),
        dimension52: get(offer, 'trackingData.dimension52', GaTrackingStringConstantEnum.No),
        dimension53: get(offer, 'trackingData.dimension53', GaTrackingStringConstantEnum.No),
        dimension54: get(offer, 'trackingData.dimension54', ''),
        ...vasData
      };
    });

    return {
      event: GaTrackingEventName.Checkout,
      gtmCustom: {
        ecommerce: {
          checkout: {
            actionField: this.actionField,
            products
          }
        }
      }
    };
  }
}
